import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import PhoneNumberSidebarSearchWidget from 'components/pure/search/phone/PhoneNumberSidebarSearchWidget';

/**
 * Render a list of <PhoneNumberSearchWidget/> in the sidebar in order
 */
class PhoneNumberSidebarSearchWidgets extends React.Component {
  static getStores() {
    return [];
  }

  static getPropsFromStores() {
    return {};
  }

  /**
   * Render a phone number search field in the sidebar
   * @param searchField {object} search field to render
   * @return {JSX} phone number search widget
   */
  renderWidget = searchField => {
    const shouldRender = this._shouldRenderWidget(searchField);
    return shouldRender ? (
      <PhoneNumberSidebarSearchWidget
        searchField={searchField}
        key={searchField.order}
        className={'search-input-phone-number-widget'}
        toggled={this.getSearchFieldToggled(searchField)}
        updateLastToggledOnSearchWidget={this.props.updateLastToggledOnSearchWidget}
      />
    ) : null;
  };

  _shouldRenderWidget(searchField) {
    const isSearchFieldToggled = this.getSearchFieldToggled(searchField);
    return (
      (this.props.shouldRenderToggled && isSearchFieldToggled) ||
      (this.props.shouldRenderNotToggled && !isSearchFieldToggled)
    );
  }

  /**
   * Return the toggled state of `searchField`
   * @param searchField {object}
   */
  getSearchFieldToggled(searchField) {
    if (this.props.searchFieldsToggled) {
      return this.props.searchFieldsToggled.get(searchField.name);
    }
    return false;
  }

  render() {
    const searchFields = this.props.searchFields.sort(sf => sf.order);
    return <div className={'search-widget'}>{searchFields.map(this.renderWidget).toArray()}</div>;
  }
}

export default connectToStores(PhoneNumberSidebarSearchWidgets);
